<template>
  <div>
    
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="success" @click="onSet">{{isSet?'取消配置':'设置配置'}}</el-button>
        <el-button size="small" type="success" icon="el-icon-plus" v-if="isSet" @click="onAdd">添加</el-button>
      </el-form-item>
    </el-form>

    <div class="tipp">
      注意事项<br />
      1， 第一条配置 最小要 0 开始，最后一条配置 最大要 = 0 <br />
      2， 区间值， 最大 > 最小<br />
      3， 配置避免出现断层， 例如配置 0-1000; 2000-3000；3000-0， 没包含 1000-2000则设置失败<br />
      4， 比例 最小值为 0.0001（万分之一）； 最大值 1 （100%）全部释放 <br />
    </div>
    <!--列表  show-summary :summary-method="getSummaries"  -->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <!-- <el-table-column align="center" prop="id" label="id">
      </el-table-column> -->
      <el-table-column align="center" label="最小">
        <template slot-scope="scope">
          <el-input v-if="isSet" :disable="isSet" v-model="scope.row.min" onkeyup='this.value = this.value.replace(/[^\d^\.?]+/g, "").replace(/^0+(\d)/, "$1") || "" ' />
          <p v-else>{{ scope.row.min }}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="最大">
        <template slot-scope="scope">
          <el-input v-if="isSet" v-model="scope.row.max" onkeyup='this.value = this.value.replace(/[^\d^\.?]+/g, "").replace(/^0+(\d)/, "$1").replace(/^\./, "0.").match(/^\d*(\.?\d{0,4})/g) || "" ' />
          <p v-else>{{ scope.row.max }}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="提现比例（每日）">
        <template slot-scope="scope">
          <el-input v-if="isSet" v-model="scope.row.prop" onkeyup='this.value = this.value.replace(/[^\d^\.?]+/g, "").replace(/^0+(\d)/, "$1").replace(/^\./, "0.").match(/^\d*(\.?\d{0,4})/g) || "" ' />
          <p v-else>{{ scope.row.prop }}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" v-if="isSet">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click.native.prevent="deleteRow(scope.$index, listData)">删除</el-button>
        </template>
      </el-table-column>
      
    </el-table>

    <div class="mt" v-if="isSet">
      <el-button size="small" type="primary" @click="AddGalex">确定修改</el-button>
    </div>

  </div>
</template>
<!-- e.target.value.replace(/[^\d^\.?]+/g, "").replace(/^0+(\d)/, "$1").replace(/^\./, "0.").match(/^\d*(\.?\d{0,2})/g) || ""; -->
  
<script>
import { LWithdrawConfigs,  SetLWithdrawConfigs } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      formInline: {
      },
      isSet: false,
      listData: [], //用户数据
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata() {
      this.loading = true
      LWithdrawConfigs()
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },

    onChange(e){
      console.log(e)
      
      console.log(this.listData)
    },

    onAdd(){
      // this.listData[this.listData.length]
      this.isSet = true
      let obj = {
        min:'',
        max:'',
        prop:''
      }
      this.listData.push(obj)
    },
    onSet(){
      this.isSet = !this.isSet
      if(this.isSet == false){
        this.getdata()
      }
    },

    //显示编辑界面
    AddGalex() {
      // 判断数组元素是否都为字符串

      let some = this.listData.some((item)=>{
        if(parseFloat(item.max) >= 0 && parseFloat(item.prop) >= 0 && parseFloat(item.min) >= 0){
          // console.log(parseFloat(item.max))
        }else{
          return true
        }
      })

      if(some){
        this.$message({
            type: 'error',
            message: '配置不可为空!'
        });
        return
      }

      for (let i = 0; i < this.listData.length; i++) {
        if (typeof this.listData[i].min == 'string') {
          this.listData[i].min = parseFloat(this.listData[i].min)
        }
        if (typeof this.listData[i].max == 'string') {
          this.listData[i].max = parseFloat(this.listData[i].max)
        }
        if (typeof this.listData[i].prop == 'string') {
          this.listData[i].prop = parseFloat(this.listData[i].prop)
        }
        // console.log(this.listData[i].min)
        // console.log(this.listData[i].max)
        // console.log(this.listData[i].prop)
        // console.log('--',typeof parseFloat(this.listData[i].max))
      }

      console.log(this.listData)
      this.$confirm('是否修改配置', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          SetLWithdrawConfigs({list:this.listData}).then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.message || '失败'
              })
            } else {
              this.$message({
                type: 'success',
                message: '成功修改配置!'
              });
              this.isSet = false
              this.getdata()
            }
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      
    },

    deleteRow(index, rows) {
        this.$confirm('是否删除', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          rows.splice(index, 1);
          // console.log(1)
          // SetLWithdrawConfigs({list:this.listData}).then(res => {
          //   this.loading = false
          //   if (res.code != 0) {
          //     this.$message({
          //       type: 'info',
          //       message: res.message
          //     })
          //   } else {
          //     this.$message({
          //       type: 'success',
          //       message: '删除成功!'
          //     });
          //     this.getdata()
          //   }
          // })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
          this.getdata()
          
        });
      
    },
  }
}
</script>
  
<style scoped>
.mt{
  margin-top: 30px;
}
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
p{font-size: 14px;color: rgb(22, 12, 163);}
.tipp{
  color: #666;
  font-size: 13px;
  margin-bottom: 20px;
}
</style>
  
   
   


// WEBPACK FOOTER //
// src/views/lucky/Withdraw.vue